<template>
  <v-app>
    <v-main>
      <div v-if="$isMobile()" key="mobile" :style="style">
        <v-img
          :src="require('@/assets/C_RGB APP.png')"
          position="center"
          style="margin:auto;width:50%;"
        ></v-img>
      </div>
      <Home v-else />
    </v-main>
  </v-app>
</template>

<script>
import Home from "./views/Home";

export default {
  name: "App",

  components: {
    Home
  },
  computed: {
    style() {
      return (
        "height:100vh;background-image: url('https://source.unsplash.com/featured/" +
        window.innerWidth +
        "x" +
        window.innerHeight +
        "/?pet'); background-size:cover ; background-repeat: no-repeat;"
      );
    }
  },
  mounted() {
    if (this.$isMobile) {
      window.addEventListener("beforeinstallprompt", e => {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        // Stash the event so it can be triggered later.
        // let deferredPrompt = e;
        // Update UI notify the user they can install the PWA
      });
    }
  },

  data: () => ({
    //
  })
};
</script>
